/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PublicChatMessageSchemaRole } from './publicChatMessageSchemaRole';
import type { PublicChatMessageSchemaUiPartsItem } from './publicChatMessageSchemaUiPartsItem';

export interface PublicChatMessageSchema {
  role: PublicChatMessageSchemaRole;
  ui_parts: PublicChatMessageSchemaUiPartsItem[];
  created_at: string;
}
